import home from './home';
import general from './general';
import validator from './validator';
import accessTerm from './accessTerm';
import renewCertificate from './renewCertificate';
import cadesSignature from './cadesSignature';
import validateAccess from './validateAccess';

const esMx = {
  home,
  general,
  validator,
  accessTerm,
  renewCertificate,
  cadesSignature,
  validateAccess,
};

export default esMx;
